import {
  animate,
  style,
  transition,
  trigger,
  animation,
} from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';

/**
 * SlideInCardComponent
 *
 * @export SlideInCardComponent
 */
@Component({
  selector: 'app-slide-in-card',
  templateUrl: './slide-in-card.component.html',
  styleUrls: ['./slide-in-card.component.scss'],
  animations: [
    trigger('slide', [
      transition(
        ':enter',
        [
          style({ transform: 'translateX(-100%)' }),
          animate('{{speed}}'),
        ],
        { params: { speed: '200ms' } },
      ),
    ]),
  ],
})
export class SlideInCardComponent implements OnInit {
  /**
   * Input for sliding animation speed
   */
  @Input()
  speed = '200ms ease-in';

  /**
   * Creates an instance of SlideInCardComponent.
   */
  constructor() {}

  /**
   * Does Nothing
   */
  ngOnInit() {}
}
